import { MagnifyingGlassIcon } from '@radix-ui/react-icons';
import { Link, useParams } from '@tanstack/react-router';
import { EmptyState } from '@/components/states';
import { Button } from '@/components/ui/button';

export function BrandNotFound() {
  const { brandId } = useParams({ strict: false });
  return (
    <EmptyState
      icon={<MagnifyingGlassIcon />}
      title="Brand not found"
      description={brandId ? `There's no brand #${brandId}. It may have been deleted.` : undefined}
      action={
        <Button variant="outline" asChild>
          <Link to="/brands">Back to brands</Link>
        </Button>
      }
    />
  );
}
